import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UICPMan = {
    name: 'Compliance AD setup',
    imageUrl: '../../images/CPMan.png',
    imageSize: "99%",
    bradius: 20,
  };

const UICPADResults = {
    name: 'AD Monitor Results',
    imageUrl: '../../images/CPADResults.png',
    imageSize: "99%",
    bradius: 20,
  };

const UICPMSSecscore = {
    name: 'MS Secure Score',
    imageUrl: '../../images/CPMSSecscore.png',
    imageSize: "99%",
    bradius: 20,
  };

const UICPMSSecactions = {
    name: 'Secure Score Actions',
    imageUrl: '../../images/CPMSSecactions.png',
    imageSize: "99%",
    bradius: 20,
  };

const UICPRiskassess = {
    name: 'Cyber Risk Assessment',
    imageUrl: '../../images/CPRiskassess.png',
    imageSize: "99%",
    bradius: 20,
  };

const UICPReports = {
    name: 'Cyber Risk Reports',
    imageUrl: '../../images/CPReports.png',
    imageSize: "65%",
    bradius: 20,
  };


export const CPMan = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Set up AD Monitor</b><br/><br/>
      To set up your AD monitor schedule you need to navigate to Compliance &gt; Set up AD Monitor<br/><br/>
      <b>Azure AD Monitor </b><br/><br/>
      In order to create an AD Monitor for Azure AD you need to have configured your Office 365 
      setup first, which is outlined in Admin &gt; System Config. <br/><br/>
      To set up Azure AD Monitor: <br/><br/>
      Provide the name of the monitor, and then select monitor type Azure AD.<br/><br/>
      Select if you want to be notified with a summary once the scan is finished, and the Schedule type that you want: <br/>
      <ul style={{marginLeft: '4em'}}>
      <li>Now - this is where the scan will run now, and the scan will run within a 5 minute window </li>
      <li>One-time - Schedule a one-time scan to run in the future </li>
      <li>Recurring - This is where you set you scan to run weekly, Monthly or Quarterly </li></ul><br/>
      Then submit your monitor. <br/><br/>
      <b>On-prem AD Monitor </b><br/><br/>
      Provide the name of the monitor, and then select monitor type On-prem AD.  <br/><br/>
      You will need to select from the list of server machines select the one that is your AD domain controller. <br/><br/>
      You can leave the Credentials set to default. <br/><br/>
      Select the Schedule type that you want: 
      <ul style={{marginLeft: '4em'}}>
      <li>Now - this is where the scan will run now, and the scan will run within a 5-minute window</li>
      <li>One-time - Schedule a one-time scan to run in the future </li>
      <li>Recurring - This is where you set you scan to run weekly, Monthly or Quarterly </li></ul>
      Select if you want to be notified with a summary once the scan is finished. <br/><br/>
      Then submit your monitor. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPMan.imageUrl}
        alt={'Image of ' + UICPMan.name}
        style={{
          width: UICPMan.imageSize,
          borderRadius: UICPMan.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const CPADResults = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>AD Monitor Results</b><br/><br/>
      Select the scan date under “Select date” and select the AD monitor you want to see the results for. <br/><br/>
      Scan results include the number of domain controllers that are enabled, the number of enabled 
      and disabled users, information about their activity, users who were active within the last 30 
      days and prior to the last 30 days, users who never change their passwords and whose passwords 
      never expire, the number of computers present in the environment, information about the groups 
      in domains (such as who all have admin rights), and more. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPADResults.imageUrl}
        alt={'Image of ' + UICPADResults.name}
        style={{
          width: UICPADResults.imageSize,
          borderRadius: UICPADResults.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const CPMSSecscore = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Microsoft Secure Score</b><br/><br/>
      The Microsoft Secure Score Dashboard provides you with scores and metrics 
      on how you are performing on security within Microsoft Cloud, along with 
      the items that you must complete in order to strengthen security settings. 
      It helps you reduce the risk of data leakage and account compromise, 
      and meet compliance requirements. <br/><br/>
      To go to Microsoft Secure Score, navigate to the main menu. Go to Compliance &gt; Microsoft Secure Score. <br/><br/>
      <b>Risk Grades</b><br/>
      These are the current and previous (shown below the current risk grade in a 
      smaller font size) risk grades assigned to your configuration of your Microsoft 
      Cloud Environment. Switch between reporting periods by selecting either M or Q 
      (for Month and Quarter).<br/><br/>
      <b>Secure Score</b><br/>
      View your Microsoft Cloud security performance percentage and the number of points 
      you have achieved out of the total number. <br/><br/>
      <b>Breakdown by Category</b><br/>
      This is an overview of the percentage breakdown for your Microsoft Cloud Environment 
      (Identity, Data, and Apps) of what you have completed and what you have left to do. <br/><br/>
      <b>Comparison by Tenant Size and Total Seats</b><br/>
      See how you compare to other similar-sized organizations and their secure configuration standard. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPMSSecscore.imageUrl}
        alt={'Image of ' + UICPMSSecscore.name}
        style={{
          width: UICPMSSecscore.imageSize,
          borderRadius: UICPMSSecscore.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const CPMSSecactions = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Secure Score Recommended Actions</b><br/><br/>
      The list of recommended actions are ranked by priority of what you should have implemented 
      within your Microsoft Cloud environment. <br/><br/>
      There is a filter that you can use to quickly filter the recommended list to point 
      out items as completed, not-started, data etc. <br/><br/>To view the details of a 
      recommendation you can click any of the Recommended Actions. This will expand that 
      particular row and provide you with more information on the action, current 
      implementation status, and next steps.  <br/><br/>
      Follow the link under Next Steps to go to the right location to configure the required settings. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPMSSecactions.imageUrl}
        alt={'Image of ' + UICPMSSecactions.name}
        style={{
          width: UICPMSSecactions.imageSize,
          borderRadius: UICPMSSecactions.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const CPRiskassess = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Risk Assessment Breakdown</b><br/><br/>
      The Overall Risk Assessment Breakdown tells you which of the CYRISMA scans 
      you&squo;ve completed, and which ones are pending. You can view your overall 
      status on the scans in the Vulnerability, Data Sensitivity and Secure Baseline 
      categories, and also see whether the Dark Web Setup for your instance is 
      complete or pending.  <br/><br/>
      Additionally, you have the option to start any of the scans that are pending 
      right from the Risk Assessment Breakdown list. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPRiskassess.imageUrl}
        alt={'Image of ' + UICPRiskassess.name}
        style={{
          width: UICPRiskassess.imageSize,
          borderRadius: UICPRiskassess.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const CPReports = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Generate Reports</b><br/><br/>
      Generate an Overall Risk Assessment report and select a recipient to send it to. 
      The report presents you with a breakdown of your cyber risk based on the latest 
      assessment of your environment. Each risk category and scan result is accompanied 
      by a score/grade, with A+ representing low risk of compromise or breach and F 
      representing extremely high risk. The report covers scan results and assessment 
      highlights for Vulnerability Assessment, Data Sensitivity, Secure Configurations 
      and Dark Web Monitoring.  <br/><br/>
      You can also generate an Overall Risk Assessment Presentation designed especially 
      for easier communication with the board, senior management and other stakeholders. 
      It collates the key findings under all scan categories and features in the platform 
      and provides an overview of the security gaps in your IT environment in a concise 
      document. 
      </div>
      <div style={helpimg}>
      <img
        src={UICPReports.imageUrl}
        alt={'Image of ' + UICPReports.name}
        style={{
          width: UICPReports.imageSize,
          borderRadius: UICPReports.bradius,
        }}
      />
      </div>
    </div>
  );
};
